/**
 * Application footer.
 */

/**
 * Minimal footer with credits.
 */
export function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-4">
      <div className="container mx-auto px-4">
        <p className="text-center text-slate-500 text-sm">
          Powered by Claude AI | Based on D&D BECMI Rules (1983)
        </p>
      </div>
    </footer>
  );
}
